import { z } from 'zod';

export const MedicalNecessityCheckBlockConfigSchema = z.object({
  insuranceProvider: z.string({ message: 'Insurance Provider is required' }).min(1),
  diagnoses: z.string({ message: 'Diagnosis Codes is required' }).min(1),
  procedureCptCodes: z.string({ message: 'Procedure CPT Codes is required' }).min(1),
  procedureServiceDate: z.string().optional(),
});

export type MedicalNecessityCheckBlockConfig = z.infer<
  typeof MedicalNecessityCheckBlockConfigSchema
>;

export const DiagnosesSchema = z.array(z.string());
export const ProcedureServiceDateSchema = z.string().date();
